var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('VHeader',{staticClass:"tabBar"}),_c('div',{staticClass:"layout_item"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }